import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getCourse = (id) => httpClient.get(apis.GET_COURSE + id);
export const addToFavoriteList = (payload) =>
  httpClient.post(apis.POST_VIDEOS_COLLECT, { ...payload }, { ignore: true });

export const getDiagnosisInfo = (id) => httpClient.get(apis.GET_DIAGNOSIS_INFO + id);
export const getCourseTaskStatus = (payload) => httpClient.get(apis.getCourseTaskStatus(payload));
export const getCourseMultiTaskStatus = (payload) =>
  httpClient.get(apis.getCourseMultiTaskStatus(payload));
export const getCourseMyTaskStatus = (payload) =>
  httpClient.get(apis.getCourseMyTaskStatus(payload));

export const getClassRestrictionWebTreePath = (payload) =>
  httpClient.get(apis.getClassRestrictionWebTreePath(payload));
